import useLazyQuery from "../useLazyQuery"

export const useDeleteEntityQuery = (entityId = "Error") => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/entities/${entityId}`
	return useLazyQuery<void, void>(url, "DELETE")
}
